import { gql } from '@apollo/client';

export const ENTITY_USAGES_QUERY = gql`
  query entityUsages($resourceName: String!, $id: Int!) {
    entityUsages(resourceName: $resourceName, id: $id) {
      entityUsages {
        name
        entity
        entityId
      }
      replaceWith {
        value
        label
      }
    }
  }
`;

export const ENTITY_USED_IN_FUTURE_JOBS = gql`
  query entityUsedInFutureJobs($userIds: [Int!], $companyIds: [Int!], $serviceIds: [Int!]) {
    entityUsedInFutureJobs(userIds: $userIds, companyIds: $companyIds, serviceIds: $serviceIds)
  }
`;
